import dayjs from 'dayjs';
import _ from 'lodash';
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const API = {
  agency: {
    path: '/operation-lists?filters[id_department][short_description]=AG&populate[id_department]=%2A&populate[id_marina]=%2A&populate[id_service]=%2A&populate[id_user_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_mexal_person_in_charge]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name, surname&populate[id_reservation][populate][id_arrival_departure_formality][fields][0]=id&populate[id_yacht][populate][id_attendance][populate][id_user_provision][populate][id_users_permissions_user][fields][0][1]=name,surname&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&[populate][id_reservation][populate][id_booking][populate][id_marina]=%2A&[populate][id_supplier]=%2A&populate[id_reservation][populate][id_arrival_departure_formality][fields][1]=value&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_teams]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      meta: data?.meta,
      data: data?.data.map((item) => ({
        id: item?.id,
        attributes: {
          ...item?.attributes,
          OC_BC_number_id: {
            OC_BC_number: item?.attributes.OC_BC_number,
            id: item?.id,
          },
          OF_BF_number_id: {
            OF_BF_number: item?.attributes.OF_BF_number,
            id: item?.id,
          },
          OC_fees_id: {
            OC_fees: item?.attributes.OC_fees,
            id: item?.id,
          },
          check_in_out_date: {
            requested_date: item?.attributes.requested_date,
            check_out_date: item?.attributes?.check_out_date,
          },
          requested_hour_id: {
            requested_hour: item?.attributes.requested_hour,
            id: item?.id,
          },
          id: item?.id,
          status_operation_booking_id: {
            status_operation_booking: item?.attributes.status_operation_booking,
            id: item?.id,
          },
          supplier_correspondent_id: {
            supplier_correspondent: item?.attributes.supplier_correspondent,
            id: item?.id,
          },
          tender_id: {
            tender: item?.attributes?.tender,
            id: item?.id,
            reservation_type:
              item?.attributes?.id_reservation?.data?.attributes
                ?.reservation_type,
          },
          isps_id: {
            isps: item?.attributes?.isps,
            id: item?.id,
            reservation_type:
              item?.attributes?.id_reservation?.data?.attributes
                ?.reservation_type,
          },
          duplicate: item,
          reservation_type_id: {
            reservation_type: item?.attributes?.id_reservation?.data?.attributes?.reservation_type,
            booking: item?.attributes?.id_reservation?.data?.attributes?.id_booking?.data
          },
          status_billing_id: {
            status_billing: item?.attributes.status_billing,
            id: item?.id,
          },
          billing_notes_id: {
            billing_notes: item?.attributes.billing_notes,
            id: item?.id,
          },
        },
      })),
    }),
  },
  operation: {
    path: '/operation-lists/{{id}}?populate[id_reservation_piloti_in][populate][id_operation_list]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name, surname&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_department]=%2A&populate[id_marina]=%2A&populate[id_mexal_person_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_reservation][populate][id_arrival_departure_formality]=%2A&populate[id_service]=%2A&populate[id_yacht][populate][id_flag]=%2A&populate[id_user_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_user_last_updated][populate][id_users_permissions_user]=%2A&populate[id_reservation_piloti_out]=%2A&[populate][id_reservation][populate][id_booking]=%2A&populate[id_yacht][populate][id_attendance][populate][id_user_provision][populate][id_users_permissions_user][fields][0][1]=name,surname&populate[id_reservation_piloti_in][populate][id_yacht][fields][0]=yacht_name&[populate][id_supplier]=%2A&populate[id_item]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null
  },
  update: {
    path: '/operation-lists/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        id_agent_NA: body?.id_agent_NA?.id,
        id_mexal_person_in_charge: body?.id_mexal_person_in_charge?.id
          ? body?.id_mexal_person_in_charge?.id
          : null,
        status_operation_booking: body?.status_operation_booking,
        id_yacht: body?.id_yacht?.id,
        // id_marina: body?.id_marina?.id,
        // id_service: body?.id_service?.id,
        id_technical_work: body?.id_technical_work?.id,
        status_operation_BF: body?.status_operation_BF?.id,
        status_operation_BC: body?.status_operation_BC?.id,
        check_out_date: body?.check_out_date
          ? dayjs(body?.check_out_date).format('YYYY-MM-DD')
          : null,
        operation_date: body?.operation_date
          ? dayjs(body?.operation_date).format('YYYY-MM-DD')
          : null,
        requested_date: body?.requested_date
          ? dayjs(body?.requested_date).format('YYYY-MM-DD')
          : null,
        requested_hour: body?.requested_hour
          ? dayjs(body?.requested_hour, 'HH:mm:ss').format('HH:mm:ss')
          : null,
        account_type: body?.account_type?.id,
        OC_fees: _.isEmpty(body?.OC_fees) ? null : body?.OC_fees,
        selling_price: _.isEmpty(body?.selling_price)
          ? null
          : body?.selling_price,
        purchase_price: _.isEmpty(body?.purchase_price)
          ? null
          : body?.purchase_price,
        id_reservation_piloti_in: body?.id_reservation_piloti_in?.id,
        type_of_contact: body?.type_of_contact?.id,
        id_item: body?.id_item?.id ?? null,
        status_billing: body?.status_billing,
      },
    }),
  },
  delete: {
    path: '/operation-lists/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/operation-lists',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
          id_agent_NA: body?.id_agent_NA?.id,
          id_mexal_person_in_charge: body?.id_mexal_person_in_charge?.id,
          id_yacht: body?.id_yacht?.id,
          id_service: body?.id_service?.id,
          id_technical_work: body?.id_technical_work?.id,
          status_operation_booking: body?.status_operation_booking,
          status_operation_BF: body?.status_operation_BF?.id,
          status_operation_BC: body?.status_operation_BC?.id,
          check_out_date: body?.check_out_date
            ? dayjs(body?.check_out_date).utc()
            : null,
          operation_date: body?.operation_date
            ? dayjs(body?.operation_date).format('YYYY-MM-DD')
            : null,
          requested_date: body?.requested_date
            ? dayjs(body?.requested_date).format('YYYY-MM-DD')
            : null,
          requested_hour: body?.requested_hour
            ? dayjs(body?.requested_hour, 'HH:mm:ss').format('HH:mm:ss')
            : null,
          account_type: body?.account_type?.id,
          port: body?.port?.id,
          OC_fees: _.isEmpty(body?.OC_fees) ? null : body?.OC_fees,
          selling_price: _.isEmpty(body?.selling_price)
            ? null
            : body?.selling_price,
          purchase_price: _.isEmpty(body?.purchase_price)
            ? null
            : body?.purchase_price,
          type_of_contact: body?.type_of_contact?.id,
          id_item: body?.id_item?.id ?? null,
        },
      };
    },
  },
  createReservation: {
    path: '/reservations',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
          id_operation_list: body?.id_operation_list,
          port: body?.port?.id,
          service_date: body?.service_date
            ? dayjs(body?.service_date).format('YYYY-MM-DD')
            : null,
          service_time: body?.service_time
            ? dayjs(body?.service_time, 'HH:mm:ss').format('HH:mm:ss')
            : null,
          required_vehicle: body?.required_vehicle?.id,
          crew_guest: body?.crew_guest?.id,
          payment_type: body?.payment_type ? body?.payment_type?.id : null,
          check_in_date: body?.check_in_date
            ? dayjs(body?.check_in_date).utc()
            : null,
          check_out_date: body?.check_out_date
            ? dayjs(body?.check_out_date).utc()
            : null,
          place_medical: body?.place_medical?.id,
          pickup_date: body?.pickup_date
            ? dayjs(body?.pickup_date).format('YYYY-MM-DD')
            : null,
          drop_off_date: body?.drop_off_date
            ? dayjs(body?.drop_off_date).format('YYYY-MM-DD')
            : null,
          requested_service_ticket: body?.requested_service_ticket?.id,
          return_date: body?.return_date
            ? dayjs(body?.return_date).format('YYYY-MM-DD')
            : null,
          return_time: body?.return_time
            ? dayjs(body?.return_time, 'HH:mm:ss').format('HH:mm:ss')
            : null,
          requested_service_beauty: body?.requested_service_beauty?.id,
          mode_beauty: body?.mode_beauty?.id,
          requested_service_clean: body?.requested_service_clean?.id,

          covid_test_type: body?.covid_test_type?.id,
          check_in_time: body?.check_in_time
            ? dayjs(body?.check_in_time, 'HH:mm:ss').format('HH:mm:ss')
            : null,
          check_out_time: body?.check_out_time
            ? dayjs(body?.check_out_time, 'HH:mm:ss').format('HH:mm:ss')
            : null,
          id_reservation_piloti_in: body?.id_reservation_piloti_in?.id,
          note: body?.note_reservation,

          //ARRIVAL DEPARTURE FORMALITIES
          id_arrival_departure_formality:
            body?.id_arrival_departure_formality?.id,
          pax_number: _.isEmpty(body?.pax_number) ? null : body?.pax_number,

          //BUNKER
          type_service_bunker: body?.type_service_bunker?.id,

          //PARK PERMIT
          permit_type: body?.permit_type?.id,
        },
      };
    },
  },
  updateReservation: {
    path: '/reservations/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        port: body?.port?.id,
        id_yacht: body?.id_yacht?.id,
        service_date: body?.service_date
          ? dayjs(body?.service_date).format('YYYY-MM-DD')
          : null,
        service_time: body?.service_time
          ? dayjs(body?.service_time, 'HH:mm:ss').format('HH:mm:ss')
          : null,
        required_vehicle: body?.required_vehicle?.id,
        crew_guest: body?.crew_guest?.id,
        payment_type: body?.payment_type ? body?.payment_type?.id : null,
        check_in_date: body?.check_in_date
          ? dayjs(body?.check_in_date).utc()
          : null,
        check_out_date: body?.check_out_date
          ? dayjs(body?.check_out_date).utc()
          : null,
        place_medical: body?.place_medical?.id,
        place_details_medical: body?.place_details_medical,
        pickup_date: body?.pickup_date
          ? dayjs(body?.pickup_date).format('YYYY-MM-DD')
          : null,
        drop_off_date: body?.drop_off_date
          ? dayjs(body?.drop_off_date).format('YYYY-MM-DD')
          : null,
        requested_service_ticket: body?.requested_service_ticket?.id,
        return_date: body?.return_date
          ? dayjs(body?.return_date).format('YYYY-MM-DD')
          : null,
        return_time: body?.return_time
          ? dayjs(body?.return_time, 'HH:mm:ss').format('HH:mm:ss')
          : null,
        requested_service_beauty: body?.requested_service_beauty?.id,
        mode_beauty: body?.mode_beauty?.id,
        requested_service_clean: body?.requested_service_clean?.id,
        covid_test_type: body?.covid_test_type?.id,
        check_in_time: body?.check_in_time
          ? dayjs(body?.check_in_time, 'HH:mm:ss').format('HH:mm:ss')
          : null,
        check_out_time: body?.check_out_time
          ? dayjs(body?.check_out_time, 'HH:mm:ss').format('HH:mm:ss')
          : null,
        id_agent_NA: body?.id_agent_NA?.id,
        id_mexal_person_in_charge: body?.id_mexal_person_in_charge?.id,
        note: body?.note_reservation,

        //Arrival formalities
        id_arrival_departure_formality:
          body?.id_arrival_departure_formality?.id,
        id_reservation_piloti_in: body?.id_reservation_piloti_in?.id,
        pax_number: _.isEmpty(body?.pax_number) ? null : body?.pax_number,

        //BUNKER
        type_service_bunker: body?.type_service_bunker?.id,

        //PARK PERMIT
        permit_type: body?.permit_type?.id,
      },
    }),
  },
  updateAll: {
    path: '/operation-lists',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
  duplicate: {
    path: '/operation-lists',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      const data = body?.attributes;

      return {
        data: {
          ...data,
          id_service: data?.id_service?.data?.id,
          id_marina: data?.id_marina?.data?.id,
          operation_date: dayjs().format('YYYY-MM-DD').toString(),
          id_user_in_charge: data?.id_user_in_charge?.data?.id,
          id_mexal_person_in_charge: data?.id_mexal_person_in_charge?.data?.id,
          is_cagliari: false,
          id_department: data?.id_department?.data?.id,
          id_yacht: { id: data?.id_yacht?.data?.id },
        },
      };
    },
  },
  duplicateReservation: {
    path: '/reservations',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      const data = body?.attributes?.id_reservation?.data?.attributes;

      return {
        data: {
          ...data,
          id_yacht: body?.attributes?.id_yacht?.data?.id,
          id_operation_list: body?.id_operation_list,
          id_arrival_departure_formality:
            data?.id_arrival_departure_formality?.data?.id,
        },
      };
    },
  },
  servicesOperationList: {
    path: '/service-operation-lists?populate[id_department]=%2A&filters[id_department][short_description]=AG&sort[service]=asc',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data.map((item) => ({
        name: item.attributes.service,
        id: item.id,
      })),
  },
  sendEmail: {
    path: '/reservations/sendReservationInfo',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
  },
};
